import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { StripeProvider } from 'react-stripe-elements';

import routes from './routes';
import store from './reduxStore';

import 'rype-bootstrap';
import './index.css';

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

Sentry.init({
  dsn: "https://494b052686ba4adba72276a9829728e2@sentry.io/2500437",
  enabled: process.env.NODE_ENV != 'development' && process.env.NODE_ENV != 'test',
  environment: process.env.NODE_ENV,
  release: `rype-web-client@${process.env.REACT_APP_VERSION}`,
});

ReactDOM.render(
  <Provider store={store}>
    <StripeProvider apiKey={STRIPE_PUBLISHABLE_KEY}>
      <Router routes={routes} history={browserHistory} />
    </StripeProvider>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js